/**
 * Shared lazy Firebase app instance. Auth and Analytics both hang off the
 * same app; the SDK chunk loads on first use, never in the core bundle.
 */
import { FIREBASE_CONFIG } from './config.js';

let appPromise = null;

/** @returns {Promise<import('firebase/app').FirebaseApp>} */
export function getFirebaseApp() {
    if (!appPromise) {
        appPromise = import('firebase/app').then(({ initializeApp, getApps, getApp }) =>
            getApps().length ? getApp() : initializeApp(FIREBASE_CONFIG));
    }
    return appPromise;
}
